import isVerifiedPortfolioCompany from "./isVerifiedPortfolioCompany";

/*
 * Returns true if the portfolio company is not verified and has a requested company.
 */
export default (portfolioCompany) =>
  !isVerifiedPortfolioCompany(portfolioCompany) &&
  Boolean(portfolioCompany?.requested_company);
